import type { AxiosResponse } from 'axios'

import axiosInstance from '@/axios'
import type {
  IMenuItem,
  IRole,
  TAuthCurrentUserState,
  TSignupData,
} from '@/interfaces'

const authRequests = {
  activateAccount: async (
    accessToken: string
  ): Promise<AxiosResponse<{ token: { bearer: string } }>> => {
    return await axiosInstance.post('/auth/activate-account', {
      code: accessToken,
    })
  },
  authForgotPwd: async (
    email: string
  ): Promise<AxiosResponse<{ code: string; validated: boolean }>> => {
    return await axiosInstance.post('/auth/forgot-pwd', {
      email,
    })
  },
  authLogin: async (
    signinData: string
  ): Promise<AxiosResponse<{ token: string; user: TAuthCurrentUserState }>> => {
    return await axiosInstance.post('/auth/token', { data: signinData })
  },
  authMe: async (): Promise<AxiosResponse<TAuthCurrentUserState>> => {
    return await axiosInstance.get('/auth/me')
  },
  authResetPwd: async ({
    code,
    password,
  }: {
    code: string | null
    password: string
  }): Promise<AxiosResponse<{ token: { bearer: string } }>> => {
    return await axiosInstance.post('/auth/reset-pwd', {
      code,
      password,
    })
  },
  authSignup: async (
    signupData: TSignupData
  ): Promise<AxiosResponse<{ created: boolean }>> => {
    return await axiosInstance.post('/auth/signup', signupData)
  },
  authValidateForgotPwd: async (
    accessToken: string
  ): Promise<AxiosResponse<{ resetPwdCode: string; validated: boolean }>> => {
    return await axiosInstance.post('/auth/validate-forgot-pwd', {
      code: accessToken,
    })
  },
  changeCurrentRole: async (
    roleId: number
  ): Promise<AxiosResponse<{ changed: boolean; roles: IRole[] }>> => {
    return await axiosInstance.post('/auth/change-current-role', { roleId })
  },
  getMenu: async (): Promise<AxiosResponse<IMenuItem[]>> => {
    return await axiosInstance.get('/auth/menu')
  },
  getPermissions: async (): Promise<AxiosResponse<string[]>> => {
    return await axiosInstance.get('/auth/permissions')
  },
}

export default authRequests
